var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labeled-value-wrapper"},[_c('p',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('h4',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }